module.exports = __webpack_public_path__ + "static/media/NewDesignCheck.306491ad.svg";